// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module--content--2NfRD","appear":"styles-module--appear--1IO7q","text":"styles-module--text--1Rrvd","icon":"styles-module--icon--2hRyy"};